/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:08:35
 * @LastEditTime: 2019-08-19 02:15:02
 * @LastEditors: Please set LastEditors
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./plugins/element.js";
import ElementUI from "element-ui";
import "./assets/css/index.less";
import "./theme/index.css";
Vue.use(ElementUI);
import "font-awesome/css/font-awesome.css";
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
import VueCookie from "vue-cookie";
Vue.use(VueCookie);
Vue.use(axios);
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);
import md5 from "js-md5";
Vue.prototype.$md5 = md5;
import { post, fetch, patch, put, del } from "./until/http";
//定义全局变量
Vue.prototype.$cookies = VueCookie;
Vue.prototype.$post = post;
Vue.prototype.$get = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$delete = del;

console.log(process.env.VUE_APP_type);

if (process.env.VUE_APP_type == "development") {
  Vue.prototype.$Base_Export = "http://znwl.com/index.php/admin/v2";
} else if (process.env.VUE_APP_type == "production") {
  Vue.prototype.$Base_Export = "https://logistics.tx315.vip/admin/v2";
}
localStorage.setItem("access_tokens", VueCookie.get("access_tokens"));
import Moment from "moment";
Vue.prototype.moment = Moment;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
